import Log from "@shark/web-sdk";
import { isBrowserEnv } from "@app/utils/constants";
import { checkIsApp } from "util/DeviceInfo";
// import { checkIsApp } from '@bit/js-bridge'
import { strategyTypeEnums } from "constants/strategy";

const symbol_id = isBrowserEnv ? window.location.pathname.split("/").pop() : "";

/**
 * 是否是币本位合约
 * @param symbolId
 */
function isCoinBaseFuture(symbolId) {
  return /[A-Z]+_DMCBL/g.test(symbolId) || /[A-Z]+_SDMCBL/g.test(symbolId);
}

function getSymbolId() {
  return isBrowserEnv ? window.location.pathname.split("/").pop() : "";
}

function getType() {
  return isBrowserEnv ? window.location.search.split("&")[0].split("=")[1] : "";
}

function getQuery(key: string) {
  if (isBrowserEnv) {
    try {
      let query = new URLSearchParams(window.location.search);
      return query.get(key) || "";
    } catch (e) {
      return "";
    }
  } else {
    return "";
  }
}

function getStrategyType(businessLine) {
  let defaultStrategyType = "grid";
  let strategyType = strategyTypeEnums[businessLine][defaultStrategyType];
  if (isBrowserEnv) {
    let strategyList = window.location.pathname.split("/");
    strategyType =
      strategyList.length > 5
        ? strategyTypeEnums[businessLine][strategyList[strategyList.length - 2]]
        : strategyType;
  }
  return isBrowserEnv ? strategyType : "";
}

const type = getType();

//埋点触发页面配置
const DefaultPageInfoList = [
  // 策略机器人页面
  /**
   * 埋点id  类型  埋点中文名称  埋点英文名称 页面URL
   *
   * b6124  页面事件  网页端交易-合约交易简介-合约概述-页面  bg_web_exchange_base_futures_summarize_page "https://www.cointr.com/futures/introduction/futures-summarize
   * b6125  页面事件  网页端交易-合约交易简介-保证金概述-页面  bg_web_exchange_base_futures_margin_summarize_page "https://www.cointr.com/futures/introduction/margin-summarize
   * b6126  页面事件  网页端交易-合约交易简介-强制平仓概述-页面  bg_web_exchange_base_futures_liquidation_summarize_page https://www.cointr.com/futures/introduction/liquidation-summarize
   * b6127  页面事件  网页端交易-合约交易简介-订单概述-页面  bg_web_exchange_base_futures_order_summarize_page https://www.cointr.com/futures/introduction/order-summarize
   * b6128  页面事件  网页端交易-合约交易简介-合约交易手续费-页面  bg_web_exchange_base_futures_trading_fee_page https://www.cointr.com/futures/introduction/trading-fee
   * b6129  页面事件  网页端交易-合约交易规则-合约信息-页面  bg_web_exchange_base_futures_details_page https://www.cointr.com/futures/introduction/futures-details
   * b6130  页面事件  网页端交易-合约交易规则-交易参数-页面  bg_web_exchange_base_futures_trading_parameters_page https://www.cointr.com/futures/introduction/trading-parameters
   * b6131  页面事件  网页端交易-合约交易规则-仓位档位-页面  bg_web_exchange_base_futures_position_tier_page https://www.cointr.com/futures/introduction/position-tier
   * b6132  页面事件  网页端交易-合约交易规则-风险控制条款-页面  bg_web_exchange_base_futures_position_limit_page https://www.cointr.com/futures/introduction/position-limit
   * b6133  页面事件  网页端交易-合约交易数据-资金费率-页面  bg_web_exchange_base_futures_funding_rate_page https://www.cointr.com/futures/introduction/funding-rate
   * b6134  页面事件  网页端交易-合约交易数据-指数价格-页面  bg_web_exchange_base_futures_index_price_page https://www.cointr.com/futures/introduction/price-indexes
   * b6135  页面事件  网页端交易-合约交易数据-保险基金-页面  bg_web_exchange_base_futures_insurance_fund_page https://www.cointr.com/futures/introduction/provision-for-risks
   * b6136  页面事件  网页端交易-合约交易数据-交割数据-页面  bg_web_exchange_base_futures_delivery_data_page https://www.cointr.com/futures/introduction/delivery-data
   *
   * */
];
//默认埋点配置
const logEvent = isBrowserEnv
  ? new Log(
      {
        app_id: "cointr_web_01",
        app_name: "cointr_web",
      },
      DefaultPageInfoList.map((o) => ({
        ...o,
        curr_page_ext: o.event_tracking_ext,
      }))
    )
  : null;

export function updateStratgyPageInfoList(
  symbol: string,
  type: string,
  cb?: Function
) {
  let findIndex = DefaultPageInfoList.findIndex((o) => {
    let symbolPath =
      o.business1 === "spot" ? `trading-bot/spot/` : `trading-bot/futures/`;
    return new RegExp(o.path).test(symbolPath);
    // && o.event_tracking_ext.type
  });
  let newList = new Array(DefaultPageInfoList.length);
  newList[findIndex] = {
    event_tracking_ext: {
      symbol_id: symbol,
      type: type,
    },
  };
  logEvent
    ?.update({}, newList)
    .then(() => {
      if (cb instanceof Function) {
        cb.call(null);
      }
    })
    .catch((e) => {
      console.error("update pageInfoList failed:", e.message);
    });
}

//更新页面配置列表
// 暂时清空内容，后续彻底清除调用
export function updatePageInfoList(symbolId: string, cb?: () => void) {
  if (cb instanceof Function) {
    cb.call(null);
  }
}

export default logEvent;
